import serverCall from "../../serverCall";

const getPlans = () => {
  try {
    const response = serverCall.get(`/subscription/plans`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getActiveSubscription = () => {
  try {
    const response = serverCall.get(`/users/subscriptions/active-subscriptions`);
    return response;
  } catch (error) {
    throw error;
  }
};

const purchasePlan = (planId) => {
  const base = window.location.origin;
  try {
    const response = serverCall.post(`/subscription/purchase`, {
      plan_id: planId,
      success_url: `${base}/plans?success&session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${base}/plans?fail`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const cancelPlan = (planId) => {
  try {
    const response = serverCall.post(`/subscription/cancel`, { plan_id: planId });
    return response;
  } catch (error) {
    throw error;
  }
};

const contactUsPlan = (payload) => {
  try {
    const response = serverCall.post(`/users/contactusplan`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const getTokenStatus = () => {
  try {
    return serverCall.get(`/subscription/token-status`);
  } catch (error) {
    throw error;
  }
};

const PaymentService = {
  getPlans,
  getActiveSubscription,
  purchasePlan,
  cancelPlan,
  contactUsPlan,
  getTokenStatus,
};

export default PaymentService;
